import { UserClient, UserClientFilters, Client } from '@/type';
import api from '@/API';

export default {
  findAll(
    userId: number, filters: UserClientFilters = {}, fields: string[] = [],
  ): Promise<UserClient[]> {
    const params = Object.assign(filters, { fields: fields.join(',') || undefined });
    return api
      .get(`users/${userId}/clients`, { params })
      .then(response => response.data);
  },
  findUnassigned(userId: number, keyword?: string): Promise<Client[]> {
    return api
      .get(`users/${userId}/unassigned-clients`, { params: { keyword } })
      .then(response => response.data);
  },
};
